import { render, staticRenderFns } from "./BpRadio.vue?vue&type=template&id=6aa997ce&scoped=true&"
import script from "./BpRadio.vue?vue&type=script&lang=js&"
export * from "./BpRadio.vue?vue&type=script&lang=js&"
import style0 from "./BpRadio.vue?vue&type=style&index=0&id=6aa997ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa997ce",
  null
  
)

export default component.exports